import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CyclistService } from '../../../services/cyclist.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-merge-cyclist',
  templateUrl: './merge-cyclist.component.html',
  styleUrls: ['./merge-cyclist.component.scss'],
  providers: [MessageService],
  encapsulation: ViewEncapsulation.None
})
export class MergeCyclistComponent implements OnInit {

  user: any = {};
  partnerId: number = 0;
  selectedBike: any = {};
  selectedCyclist: any = {};

  firstCustomer: any = {};
  secondCustomer: any = {};
  mergedCustomer: any = {};

  bike: any;

  users: any = [];
  selectedUser: any = {}

  overrideNameValidation: boolean = false;

  constructor(
      public cyclistService: CyclistService,
      public messageService: MessageService
  )
  {

  }

  ngOnInit() {
    this.prepData()
  }

  prepData() {
    this.firstCustomer.ID = 0;
    this.firstCustomer.name = "";
    this.firstCustomer.nameSelected = false;
    this.firstCustomer.surname = "";
    this.firstCustomer.surnameSelected = false;
    this.firstCustomer.email = "";
    this.firstCustomer.emailSelected = false;
    this.firstCustomer.phone = "";
    this.firstCustomer.phoneSelected = false;
    this.firstCustomer.stravaProfile = false;

    this.firstCustomer.searchName = "";
    this.firstCustomer.searchSurname = "";
    this.firstCustomer.searchEmail = "";
    this.firstCustomer.searchPhone = "";

    this.firstCustomer.bikes = [];

    this.secondCustomer.ID = 0;
    this.secondCustomer.name = "";
    this.secondCustomer.nameSelected = false;
    this.secondCustomer.surname = "";
    this.secondCustomer.surnameSelected = false;
    this.secondCustomer.email = "";
    this.secondCustomer.emailSelected = false;
    this.secondCustomer.phone = "";
    this.secondCustomer.phoneSelected = false;
    this.secondCustomer.stravaProfile = false;

    this.secondCustomer.searchName = "";
    this.secondCustomer.searchSurname = "";
    this.secondCustomer.searchEmail = "";
    this.secondCustomer.searchPhone = "";

    this.secondCustomer.bikes = [];
    //this.secondCustomer.bikes = [{ name: "Bike 1", code: "1234" }];

    this.users = [];
    this.selectedUser = {};

    this.mergedCustomer.bikes = [];
    this.mergedCustomer.name = "";
    this.mergedCustomer.surname = "";
    this.mergedCustomer.email = "";
    this.mergedCustomer.phone = "";
  }

  searchEmail() {
    if (this.firstCustomer.searchEmail.length > 0 && this.firstCustomer.searchEmail.indexOf('@') > -1) {
      this.cyclistService.searchCyclistByEmail(0, this.firstCustomer.searchEmail).subscribe(cyclists => {
            this.firstCustomer.searchEmail = '';
            if (cyclists && cyclists.length > 0) {
              this.firstCustomer.ID = cyclists[0].ID;
              this.firstCustomer.name = cyclists[0].Name;
              this.firstCustomer.surname = cyclists[0].Surname;
              this.firstCustomer.email = cyclists[0].Email;
              this.firstCustomer.phone = cyclists[0].PhoneNumber;
              this.firstCustomer.stravaProfile = cyclists[0].IsStravaLinked;
              this.mergedCustomer.firstCustomerID = this.firstCustomer.ID
              this.getFirstActiveBikes();
            }
            else{
              this.messageService.add({ life: 5000, summary: "Customer 1 not found using email" });
            }
          },
          error => {
            this.messageService.add({ life: 5000, summary: "Customer 1 search failed using email" });
          });
    }

    if (this.secondCustomer.searchEmail.length > 0 && this.secondCustomer.searchEmail.indexOf('@') > -1) {
      this.cyclistService.searchCyclistByEmail(0, this.secondCustomer.searchEmail).subscribe(cyclists => {
            this.secondCustomer.searchEmail = '';
            if (cyclists && cyclists.length > 0) {
              this.secondCustomer.ID = cyclists[0].ID;
              this.secondCustomer.name = cyclists[0].Name;
              this.secondCustomer.surname = cyclists[0].Surname;
              this.secondCustomer.email = cyclists[0].Email;
              this.secondCustomer.phone = cyclists[0].PhoneNumber;
              this.secondCustomer.stravaProfile = cyclists[0].IsStravaLinked;
              this.mergedCustomer.secondCustomerID = this.secondCustomer.ID;
              this.getSecondActiveBikes();
            }
            else{
              this.messageService.add({ life: 5000, summary: "Customer 2 not found using email" });
            }
          },
          error => {
            this.messageService.add({ life: 5000, summary: "Customer 2 search failed using email" });
          });;
    }
  }

  searchPhone() {
    if (this.firstCustomer.searchPhone.length >= 9) {
      this.cyclistService.searchCyclistByPhoneFuzzy(0, this.firstCustomer.searchPhone).subscribe(cyclists => {
            this.firstCustomer.searchPhone = '';
            if (cyclists && cyclists.length > 0) {
              this.firstCustomer.ID = cyclists[0].ID;
              this.firstCustomer.name = cyclists[0].Name;
              this.firstCustomer.surname = cyclists[0].Surname;
              this.firstCustomer.email = cyclists[0].Email;
              this.firstCustomer.phone = cyclists[0].PhoneNumber;
              this.firstCustomer.stravaProfile = cyclists[0].IsStravaLinked;
              this.mergedCustomer.firstCustomerID = this.firstCustomer.ID
              this.getFirstActiveBikes();
            }
            else{
              this.messageService.add({ life: 5000, summary: "Customer 1 not found using phone number" });
            }
          },
          error => {
            this.messageService.add({ life: 5000, summary: "Customer 1 search failed using phone number" });
          });
    }

    if (this.secondCustomer.searchPhone.length >= 9) {
      this.cyclistService.searchCyclistByPhoneFuzzy(0, this.secondCustomer.searchPhone).subscribe(cyclists => {
            this.secondCustomer.searchPhone = '';
            if (cyclists && cyclists.length > 0) {
              this.secondCustomer.ID = cyclists[0].ID;
              this.secondCustomer.name = cyclists[0].Name;
              this.secondCustomer.surname = cyclists[0].Surname;
              this.secondCustomer.email = cyclists[0].Email;
              this.secondCustomer.phone = cyclists[0].PhoneNumber;
              this.secondCustomer.stravaProfile = cyclists[0].IsStravaLinked;
              this.mergedCustomer.secondCustomerID = this.secondCustomer.ID;
              this.getSecondActiveBikes();
            }
            else{
              this.messageService.add({ life: 5000, summary: "Customer 2 not found using phone number" });
            }
          },
          error => {
            this.messageService.add({ life: 5000, summary: "Customer 2 search failed using phone number" });
          });
    }
  }

  getFirstActiveBikes() {
    this.cyclistService.getBikesForCyclist(this.firstCustomer.ID).subscribe(bikes => {
      console.log(bikes);
      this.firstCustomer.bikes = [];
      bikes.forEach(bike => {
        this.firstCustomer.bikes.push(bike);
      });
    }, error => {
      this.firstCustomer.bikes = [];
    })
  }

  getSecondActiveBikes() {
    this.cyclistService.getBikesForCyclist(this.secondCustomer.ID).subscribe(bikes => {
      this.secondCustomer.bikes = [];
      bikes.forEach(bike => {
        this.secondCustomer.bikes.push(bike);
      });
    }, error => {
      this.secondCustomer.bikes = [];
    })
  }

  setName(value) {
    this.mergedCustomer.name = value;
  }
  setSurname(value) {
    this.mergedCustomer.surname = value;
  }
  setEmail(value) {
    this.mergedCustomer.email = value;
  }
  setPhone(value) {
    this.mergedCustomer.phone = value;
  }

  mergeCustomers() {
    this.mergedCustomer.firstCustomerID = this.firstCustomer.ID;
    this.mergedCustomer.secondCustomerID = this.secondCustomer.ID;
    this.mergedCustomer.bikes = [];
    this.firstCustomer.bikes.forEach(bike => { if (bike.Selected) this.mergedCustomer.bikes.push({ ID: bike.ID, LinkedBike: bike.LinkedBike ? bike.LinkedBike.ID : 0 }) });
    this.secondCustomer.bikes.forEach(bike => { if (bike.Selected) this.mergedCustomer.bikes.push({ ID: bike.ID, LinkedBike: bike.LinkedBike ? bike.LinkedBike.ID : 0 }) });

    console.log("Merging:");
    console.log(this.mergedCustomer);

    this.cyclistService.mergeCyclist(this.mergedCustomer).subscribe(
        bikes => {
          this.messageService.add({ life: 5000, summary: "Customer has been merged!" });
          this.prepData();
        },
        error => {
          this.messageService.add({ life: 10000, summary: "An error occurred while trying to merge customers, please try again later." });
          this.secondCustomer.bikes = [];
        }
    );
  }

  readyToMerge() {
    var retVal = false;

    this.mergedCustomer.bikes = [];
    this.firstCustomer.bikes.forEach(bike => { if (bike.Selected) this.mergedCustomer.bikes.push({ ID: bike.ID, LinkedBike: bike.LinkedBike ? bike.LinkedBike.ID : 0 }) });
    this.secondCustomer.bikes.forEach(bike => { if (bike.Selected) this.mergedCustomer.bikes.push({ ID: bike.ID, LinkedBike: bike.LinkedBike ? bike.LinkedBike.ID : 0 }) });

    if (!this.overrideNameValidation)
      if ( this.mergedCustomer.firstCustomerID > 0 && this.mergedCustomer.secondCustomerID > 0 && this.mergedCustomer.bikes.length > 0 &&
          this.mergedCustomer.name != "" && this.mergedCustomer.surname != "" && this.mergedCustomer.email != "" && this.mergedCustomer.phone != "")
        retVal = true;

    if (this.overrideNameValidation)
      if (this.mergedCustomer.firstCustomerID > 0 && this.mergedCustomer.secondCustomerID > 0 && this.mergedCustomer.bikes.length > 0)
        retVal = true;

    return retVal;
  }
}
